import { render, staticRenderFns } from "./OrdersRecieved.vue?vue&type=template&id=5191a3ce&scoped=true&"
import script from "./OrdersRecieved.vue?vue&type=script&lang=js&"
export * from "./OrdersRecieved.vue?vue&type=script&lang=js&"
import style0 from "./OrdersRecieved.vue?vue&type=style&index=0&id=5191a3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191a3ce",
  null
  
)

export default component.exports